<div tabindex="-1" class="gc-transfer-panel-list">
  <div [attr.data-automation-id]="'transfer-panel-user-list-header'"
    class="gc-transfer-panel-list-item js-user-list-header"
    (click)="toggleList(userList)"
    [ngClass]="{ 'highlighted': isHighlighted(userList.header) }"
    (mouseenter)="highlightItem(userList.header)">
    <svg-icon class="gc-transfer-panel-expand-icon" icon="{{ userList.expanded ? 'arrow-down' : 'arrow-right' }}">
    </svg-icon>
    <div class="gc-status-circle" [ngClass]="getUserListAvailability()"></div>
    <div>{{ 'genesysTransferPanelSearch.usersHeader' | translate }}<span> ({{ availableUsers() }}/{{ users?.length || 0 }})</span></div>
  </div>

  <div *ngIf="userList.expanded">
    <div *ngFor="let user of users" class="gc-transfer-panel-list-item second-level js-user-list-item"
      [ngClass]="{ 'highlighted': isItemHighlighted(user), 'selected': isItemSelected(user) }"
      (mouseenter)="highlightItem(user)" (click)="selectItem(user)">
      <div class="gc-status-circle" [ngClass]="getUserAvailability(user)">
        <svg-icon icon="checkmark"></svg-icon>
      </div>
      <div [attr.data-automation-id]="'transfer-panel-user'" class="js-user-name">{{ user.name }}</div>
    </div>

    <div *ngIf="canLoadMoreUsers" class="gc-transfer-panel-list-item second-level load-more js-user-list-load-more" (click)="loadMoreUsers.emit()"
      [ngClass]="{ 'highlighted': isHighlighted(userList.loadMore) }" (mouseenter)="highlightItem(userList.loadMore)">
      <span>
        {{ 'genesysTransferPanelSearch.loadMoreUsers' | translate }}
      </span>
    </div>
  </div>

  <div [attr.data-automation-id]="'transfer-panel-queue-list-header'"
    class="gc-transfer-panel-list-item js-queue-list-header"
    (click)="toggleList(queueList)"
    [ngClass]="{ 'highlighted': isHighlighted(queueList.header)}"
    (mouseenter)="highlightItem(queueList.header)">
    <svg-icon class="gc-transfer-panel-expand-icon" icon="{{ queueList.expanded ? 'arrow-down' : 'arrow-right' }}">
    </svg-icon>
    <div>{{ 'genesysTransferPanelSearch.queuesHeader' | translate }}<span class="js-queue-list-count"> ({{ queues?.length || 0 }})</span></div>
  </div>

  <div *ngIf="queueList.expanded">
    <div *ngFor="let queue of queues" class="gc-transfer-panel-list-item second-level js-queue-list-item"
      [ngClass]="{ 'highlighted': isItemHighlighted(queue), 'selected': isItemSelected(queue) }"
      (mouseenter)="highlightItem(queue)" (click)="selectItem(queue)">
      <div [attr.data-automation-id]="'transfer-panel-queue'" class="js-queue-name">{{ queue.name }}</div>
    </div>

    <div *ngIf="canLoadMoreQueues" class="gc-transfer-panel-list-item second-level load-more js-queue-list-load-more" (click)="loadMoreQueues.emit()"
      [ngClass]="{ 'highlighted': isHighlighted(queueList.loadMore) }" (mouseenter)="highlightItem(queueList.loadMore)">
      {{ 'genesysTransferPanelSearch.loadMoreQueues' | translate }}
    </div>
  </div>
</div>
